
webpack.register(
    'components/clamp-text/clamp-text',
    function() {
        return require('components/clamp-text/clamp-text');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/clamp-text/clamp-text'/>\r\n\r\n<div class=\"s-video-landing-slider-item__vote-link\" data-answer-id=\"{{id}}\">\r\n    <clamp-text text=\"{{title}}\" lines=\"2\" />\r\n</div>\r\n");